<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline ps-2 pa-1">{{ $t("planningPage.createEventHeadline") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.name"
                    :rules="[rules.required]"
                    :label="$t('planningPage.eventName')"
                    type="text"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.start_date"
                    :rules="[rules.required]"
                    :label="$t('planningPage.startDate')"
                    type="date"
                  ></v-text-field>
                </v-flex>
                <v-select
                  outline
                  v-model="start_shift"
                  :label="$t('planningPage.startShift')"
                  :rules="[rules.required]"
                  :items="shifts"
                  dense
                ></v-select>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.end_date"
                    :rules="[rules.required]"
                    :label="$t('planningPage.endDate')"
                    type="date"
                  ></v-text-field>
                </v-flex>

                <v-select
                  outline
                  v-model="end_shift"
                  :rules="[rules.required]"
                  :label="$t('planningPage.endShift')"
                  :items="shifts"
                  dense
                ></v-select>
                <v-flex>
                  <v-text-field
                    outline
                    v-model="model.last_appliance_date"
                    :rules="[rules.required]"
                    :label="$t('planningPage.lastApplianceDate')"
                    type="date"
                  ></v-text-field>
                </v-flex>
                <v-btn
                  :loading="loading"
                  block
                  @click="createEvent"
                  color="secondary"
                  dark
                  >{{ $t("planningPage.create") }}</v-btn
                >
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("planningPage.createEventTitle");
  },
  data() {
    return {
      time: null,
      start_shift: "",
      end_shift: "",
      isLoading: false,
      loading: false,
      error: false,
      model: {
        name: "",
        start_date: "",
        end_date: "",
        last_appliance_date: "",
      },
      shifts: [6, 13, 21],

      rules: {
        email: (v) => !!(v || "").match(/@/) || this.$t("planningPage.invalidEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("planningPage.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) || this.$t("planningPage.invalidPassword"),

        required: (v) => !!v || this.$t("planningPage.requiredField"),
      },
    };
  },
  mounted() {},

  methods: {
    createEvent() {
      console.log(this.model);
      if (this.$refs.form.validate()) {
        this.loading = true;

        // this.model.start_date = moment(
        //   this.model.start_date + this.start_shift
        // ).format("YYYY-MM-DD HH");
        // this.model.end_date = moment(
        //   this.model.end_date + this.end_shift
        // ).format("YYYY-MM-DD HH");
        this.start_shift += ":00:00";
        this.end_shift += ":00:00";

        this.model.start_date = this.model.start_date + " " + this.start_shift;
        this.model.end_date = this.model.end_date + " " + this.end_shift;
        console.log("START DATE");
        console.log(this.model.start_date);
        console.log("END DATE");
        console.log(this.model.end_date);

        this.model.start_date = moment(this.model.start_date).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.model.end_date = moment(this.model.end_date).format(
          "YYYY-MM-DD HH:mm:ss"
        );

        this.model.last_appliance_date = moment(
          this.model.last_appliance_date
        ).format("YYYY-MM-DD HH:mm:ss");

        this.axios
          .post(this.api.ACTIONS.EVENTS, {
            ...this.model,
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("planningPage.eventCreated"), "green");
            this.$router.push("/events");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("planningPage.checkYourInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      console.log(this.model);
      // }
    },
  },
};
</script>
